export interface CaptureClockReading {
    occurredAt: string;
    monotonicMs: number;
}

export interface CaptureClock {
    read(): CaptureClockReading;
}

const monotonicNow = (): number => {
    if (typeof performance !== "undefined" && typeof performance.now === "function") {
        return performance.now();
    }
    return Date.now();
};

export function createCaptureId(prefix: string): string {
    const safePrefix = String(prefix || "id").replace(/[^a-z0-9_-]/gi, "").toLowerCase() || "id";
    try {
        if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
            return `${safePrefix}_${crypto.randomUUID()}`;
        }
        if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
            const bytes = new Uint8Array(16);
            crypto.getRandomValues(bytes);
            const random = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
            return `${safePrefix}_${random}`;
        }
    } catch {}
    return `${safePrefix}_${Date.now()}_${Math.random().toString(36).slice(2, 14)}`;
}

export function createCaptureClock(args?: {
    wallNow?: () => number;
    monotonicNow?: () => number;
}): CaptureClock {
    const wallNow = args?.wallNow ?? Date.now;
    const readMonotonic = args?.monotonicNow ?? monotonicNow;
    const monotonicOrigin = readMonotonic();
    let previousMs = 0;

    return {
        read(): CaptureClockReading {
            const elapsed = Math.max(previousMs, readMonotonic() - monotonicOrigin);
            previousMs = elapsed;
            return {
                occurredAt: new Date(wallNow()).toISOString(),
                monotonicMs: Math.round(elapsed * 1000) / 1000,
            };
        },
    };
}
